import { defineMessages } from 'react-intl';

export default defineMessages({
  expandToFullscreen: {
    id: 'app.features.aiCompanion.expandToFullscreen',
    defaultMessage: 'Expand to fullscreen',
  },
  collapseToSidebar: {
    id: 'app.features.aiCompanion.collapseToSidebar',
    defaultMessage: 'Collapse to sidebar',
  },
  closeCompanion: {
    id: 'app.features.aiCompanion.closeCompanion',
    defaultMessage: 'Close AI Companion',
  },
  conversation: {
    id: 'app.features.aiCompanion.conversation',
    defaultMessage: 'Conversation with the AI Companion',
  },
  turnFailed: {
    id: 'app.features.aiCompanion.turnFailed',
    defaultMessage: 'Something went wrong. Please try again.',
  },
  turnRetry: {
    id: 'app.features.aiCompanion.turnRetry',
    defaultMessage: 'Try again',
  },
});
